var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState, useEffect, useRef } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, ListItem, Grid, TextField, List, ListItemText, } from "@material-ui/core";
import { SearchDialogPager } from "./SearchDialogPager";
import { SearchDialogSimplePager } from "./SearchDialogSimplePager";
import { useIsMounted } from "../../hooks/useIsMounted";
const ID_FIELD_NAME = "id";
const LABEL_FIELD_NAME = "name";
const DISABLED_FIELD_NAME = "disabled";
const EMPTY_RESPONSE = {
    data: [],
    totalCount: undefined,
};
export const SearchDialog = ({ label, name, dialogOpenProps, service, renderItem, onSelectOrClose, titleCustomElement, }) => {
    const [isLoading, setIsLoading] = useState(false);
    const scrollableContentRef = useRef();
    const [apiResponse, setApiResponse] = useState(EMPTY_RESPONSE);
    const [searchText, setSearchText] = useState(dialogOpenProps.initialSearchText);
    const [requestedSearchText, setRequestedSearchText] = useState("");
    const [requestedPage, setRequestedPage] = useState(0);
    const isMountedRef = useIsMounted();
    useEffect(() => {
        if (!searchText) {
            if (isMountedRef.current) {
                setSearchText(dialogOpenProps.initialSearchText);
            }
        }
    }, [dialogOpenProps.initialSearchText, searchText, isMountedRef]);
    useEffect(() => {
        (() => __awaiter(void 0, void 0, void 0, function* () {
            if (!dialogOpenProps.isDialogOpen) {
                return;
            }
            if (isMountedRef.current) {
                setIsLoading(true);
            }
            const response = yield service.getAll({
                query: requestedSearchText,
                page: requestedPage,
            });
            if (isMountedRef.current) {
                setApiResponse(response);
            }
            if (scrollableContentRef && scrollableContentRef.current) {
                scrollableContentRef.current.scrollTo(0, 0);
            }
            if (isMountedRef.current) {
                setIsLoading(false);
            }
        }))();
    }, [dialogOpenProps, requestedSearchText, service, requestedPage, isMountedRef]);
    const handleClose = (val) => {
        setSearchText("");
        setRequestedSearchText("");
        setRequestedPage(0);
        setApiResponse(EMPTY_RESPONSE);
        onSelectOrClose(val);
    };
    return (React.createElement(Dialog, { open: dialogOpenProps.isDialogOpen, onClose: () => handleClose(), maxWidth: "sm", fullWidth: true, scroll: "paper", PaperProps: {
            style: {
                minHeight: "80vh",
                maxHeight: "80vh",
            },
        } },
        titleCustomElement ? (titleCustomElement) : (React.createElement(DialogTitle, null,
            React.createElement(TextField, { name: "query", label: "Search for " + label + "...", "data-test": "search-field-input", fullWidth: true, autoFocus: true, value: searchText, onChange: e => setSearchText(e.target.value), onKeyUp: _ => {
                    setRequestedPage(0);
                    setRequestedSearchText(searchText);
                } }))),
        React.createElement(DialogContent, { ref: scrollableContentRef, id: "search-list-field-content-" + name },
            React.createElement(Grid, { container: true, spacing: 3 },
                React.createElement(Grid, { item: true, sm: 12 }),
                React.createElement(Grid, { item: true, sm: 12 },
                    React.createElement("div", { style: { minHeight: "100vh" } },
                        React.createElement(List, null, apiResponse.data.map(item => {
                            return (React.createElement(ListItem, { key: item[ID_FIELD_NAME], "data-test": "search-result", button: true, onClick: () => handleClose({ id: item[ID_FIELD_NAME], label: item[LABEL_FIELD_NAME] }), "data-value": item[ID_FIELD_NAME], disabled: !!item[DISABLED_FIELD_NAME] }, renderItem ? (renderItem(item)) : (React.createElement(ListItemText, { primary: item[LABEL_FIELD_NAME] }))));
                        })))))),
        React.createElement(DialogActions, null,
            React.createElement("div", { className: "SearchListFooter" },
                apiResponse.totalCount !== undefined && (React.createElement(SearchDialogPager, { isLoading: isLoading, apiResponse: apiResponse, setRequestedPage: setRequestedPage })),
                apiResponse.hasNextPage !== undefined && (React.createElement(SearchDialogSimplePager, { isLoading: isLoading, apiResponse: apiResponse, setRequestedPage: setRequestedPage }))))));
};
